import Box from '@mui/material/Box'
import { useCallback, useContext, useSyncExternalStore } from 'react'
import { UNSAFE_DataRouterContext, useLocation } from 'react-router-dom'
import { Progress } from '@/components/atoms/progress/components/Progress'

export function RouteNavigationProgress() {
  const context = useContext(UNSAFE_DataRouterContext)
  if (!context) throw new Error('RouteNavigationProgress requires RouterProvider')
  const { router } = context
  const { key: committedKey } = useLocation()
  const subscribe = useCallback((notify: () => void) => router.subscribe(notify), [router])
  // React.lazy can still be pending after the router itself has become idle.
  const getSnapshot = useCallback(
    () => router.state.navigation.state !== 'idle' || router.state.location.key !== committedKey,
    [router, committedKey]
  )
  const pending = useSyncExternalStore(subscribe, getSnapshot, getSnapshot)

  return pending ? (
    <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: theme => theme.zIndex.appBar + 1 }}>
      <Progress size='small' variant='indeterminate' aria-label='Memuat halaman' />
    </Box>
  ) : null
}
